import $ from "jquery";
import swal from "sweetalert";
import ToothFocusControls from "./ToothFocusControls.vue";
import ToothFocusButtons from "./ToothFocusButtons.vue";
import { getFullBox } from "@/components/occlusal/OcclusalTools.js";
import {
  Apps as DicomApps,
  focusDicomsTo3dPoint,
  focusAnnotation,
  unfocusAnnotation,
} from "@/components/dicom/DicomManager.js";
import {
  updateRaycaster,
  intersectTooth,
  setHighlightedToothColor,
} from "@/components/intersection";
import { drawPoint } from "../../draw/draw";

let controlsInitialized = false;
let toothFocused = false;

let ToothFocusMode = {
  isActive: false,
  enterMode: function () {
    enterToothFocusMode();
  },
  leaveMode: function (saveActiveMode) {
    leaveToothFocusMode(false, saveActiveMode);
  },
  mouseUp: function (event) {
    return true;
  },
  mouseMove: function (event) {
    return !toothFocused;
  },
  mouseClick: function (event) {
    updateRaycaster(event);
    let tooth = intersectTooth();
    focusTooth(tooth);
  },
};

function enterToothFocusMode() {
  console.log("enterToothFocusMode");
  initializeControls();
  vueApp.leaveModes(false, true);
  $(".tooth-focus-mode-item").css("display", "block");

  vueApp.activeMode = ToothFocusMode;
  ToothFocusMode.isActive = true;
}

function focusTooth(item, apps) {
  if (item && (item.isVisible || item.isSingle)) {
    toothFocused = item.isFocused = true;
    $("#toothFocusHint").css("display", "none");
    vueApp.allItems.forEach((model) => {
      if (model != item) {
        let mesh = viewer.get_model_mesh(model.id);
        if (!mesh || !mesh.geometry) return;
        mesh.visible = false;
        updateLinkedMeshesVisibility(model, mesh);
        // if (!apps)
        model.isHidden = true;
        // viewer.set_color(model.id, "transparent");
        // viewer.set_opacity(model.id, 0);
      }
    });

    let tmesh = viewer.get_model_mesh(item.id);
    if (tmesh && tmesh.visible !== undefined) {
      tmesh.visible = true;
      updateLinkedMeshesVisibility(item, tmesh);
      // let geometry = tmesh.geometry.clone();
      // geometry.applyMatrix4(tmesh.matrix);
      // let toothBox = offsetBox(geometry.boundingBox);
      // geometry.dispose();
      tmesh.geometry.computeBoundingBox();
      let toothBox = offsetBox(
        tmesh.geometry.boundingBox.clone().applyMatrix4(tmesh.matrix),
      );

      vueApp.switchToDefaultView();
      let vcenter = toothBox.center;
      vueApp.lookAtPoint(vcenter);
      viewer.camera.position.z = defaultZoom / 3 + toothBox.center.z;

      let color = vueApp.getActualColor(item);
      viewer.set_color(item.id, color);

      if (apps) focusDicomsTo3dPoint(vcenter, apps);
      else if (DicomApps) {
        let mainApp = DicomApps[0];
        if (mainApp && mainApp.allAnnotations && mainApp.isAnnotating) {
          let annotation = mainApp.allAnnotations.find((a) => a.model == item);
          if (mainApp && annotation) {
            focusAnnotation(mainApp, annotation);
          }
        } else if (vueApp.isDicomOpen) {
          focusDicomsTo3dPoint(vcenter, DicomApps);
        }
      }
    }
    // vueApp.$emit('visibilityChanged', 'focusTooth');
  }
}

function focusDicomItem(tooth) {
  if (DicomApps && tooth) {
    let tmesh = viewer.get_model_mesh(tooth.id);
    if (tmesh) {
      tmesh.geometry.computeBoundingBox();
      let toothBox = offsetBox(
        tmesh.geometry.boundingBox.clone().applyMatrix4(tmesh.matrix),
      );
      let vcenter = toothBox.center;
      focusDicomsTo3dPoint(vcenter, DicomApps);
    }
  }
}

function unfocusTooth(leaveFocusMode) {
  $("#toothFocusHint").css("display", "block");
  toothFocused = false;
  vueApp.allItems.forEach(function (model) {
    model.isHidden = model.isFocused = false;
    if (model.isVisible && !model.isDeleted) {
      let mesh = viewer.get_model_mesh(model.id);
      if (mesh) {
        mesh.visible = true;
        updateLinkedMeshesVisibility(model, mesh);
      }
    }
    // viewer.set_opacity(model.id, model.opacity);
  });

  vueApp.switchToDefaultView();

  let visibleBox = getFullBox(true);
  let vcenter = visibleBox.center;
  vueApp.lookAtPoint(vcenter);

  if (leaveFocusMode) {
    leaveToothFocusMode();
  }
  vueApp.$emit("visibilityChanged", "unfocusTooth");

  if (DicomApps) {
    let mainApp = DicomApps[0];
    if (mainApp && mainApp.allAnnotations) {
      unfocusAnnotation(mainApp, true);
    }
  }
}

function leaveToothFocusMode() {
  $(".tooth-focus-mode-item").css("display", "none");
  vueApp.activeMode = null;

  ToothFocusMode.isActive = false;
  vueApp.leaveModes(false, true);
}

function initializeControls() {
  if (!controlsInitialized) {
    var ctrls = [ToothFocusControls, ToothFocusButtons];
    ctrls.forEach((component) => {
      const componentInstance = new Vue({
        ...component,
        propsData: { mode: ToothFocusMode },
      });
      const vueContainer = document.createElement("div");
      document.getElementById("stl_wrapper").appendChild(vueContainer);
      componentInstance.$mount(vueContainer);
    });
    controlsInitialized = true;
  }
}

export {
  ToothFocusMode,
  enterToothFocusMode,
  focusTooth,
  unfocusTooth,
  focusDicomItem,
};
